import { UUID } from '../../../../../../types/shared/UUID';

export const SECTION_L_DEFINITION_ID: UUID = '17133d4d-26da-4279-afc2-3c4d13d04f84';
export const EMD_FEE_CATEGORY_DEFINITION_ID: UUID = '057dfbee-8f0d-45d5-90b4-0e5801905dfb';
